import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  usuario: string;
  aux: string;

  constructor( private router: Router ) {
    this.aux = sessionStorage.getItem("usuario");
  }

  ngOnInit() { 
    if (this.aux != null) {
      this.usuario = JSON.parse(this.aux)['login'].split('.')[0];
    }
  }

  logout() {
    sessionStorage.removeItem("usuario");
    this.router.navigateByUrl('login');
  }

}


// WEBPACK FOOTER //
// ./src/app/gerenciador/nav/nav.component.ts